let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7titD")).then(() => parcelRequire('ioc4u'));